$(document).on('click', '.header_search svg', function () {
  $(document).find('.header_search_form').addClass('active-form');
  $('body').css('overflow','hidden');
});

$(document).on('click', '.close_form', function () {
  $(document).find('.header_search_form').removeClass('active-form');
  $('body').css('overflow','auto');
  $('#PredictiveWrapper').addClass('hide');
  $(document).find('#PredictiveResults [data-type-pages]>ul').empty();
  $(document).find('#PredictiveResults [data-type-products]>.grid').empty();
  $(document).find('#PredictiveResults [data-type-collections]>ul').empty();
});

$(document).on('click', 'button[data-predictive-search-button]', function () {
  $('.hidden_submit').trigger('click');
});

var queryVal = '';

function predictiveSearch(This) {
  $(document).find('#PredictiveResults [data-type-pages]>ul').empty();
  $(document).find('#PredictiveResults [data-type-products]>.grid').empty();
  $(document).find('#PredictiveResults [data-type-collections]>ul').empty();
  var q = $(This).val();
  var b = '&resources[type]=product,page,collection'
  $.ajax('/search/suggest.json?q=' + q + b,{
    type: 'GET',
    dataType: 'json', 
    success: function(response) {
        var productSuggestions = response.resources.results.products;
        var collectionSuggestions = response.resources.results.collections;
        var pagesSuggestions = response.resources.results.pages;
        if (productSuggestions.length > 0) {
          $('#PredictiveWrapper').removeClass('hide');
          var firstProductSuggestion = productSuggestions[0];
          var productResult = `<div class="grid__item grid-product small--one-half medium-up--one-quarter aos-animate">
                                    <div class="grid-product__content">
                                      <a href="${firstProductSuggestion.url}" class="grid-product__link" data-samitapbl-handle="${firstProductSuggestion.handle}">
                                        <div class="grid-product__image-mask">
                                          <div class="grid__image-ratio grid__image-ratio--square">
                                            <img class="grid__image-contain lazyautosizes lazyloaded"  src="${firstProductSuggestion.featured_image.url}">
                                          </div>
                                        </div>
                                        <div class="grid-product__meta">
                                          <div class="grid-product__title">${firstProductSuggestion.title}</div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>`;
            $(document).find('#PredictiveResults [data-type-products]>.grid').append(productResult);
          }else{
            $('#PredictiveWrapper').addClass('hide');
          }
      
        if(collectionSuggestions.length > 0) {
          $('#PredictiveWrapper').removeClass('hide');
          var firstCollectionSuggestion = collectionSuggestions[0];
          var collectionResult = `<li>
                                      <a href="${firstCollectionSuggestion.url}">${firstCollectionSuggestion.title}</a>
                                    </li>`;
          $(document).find('#PredictiveResults [data-type-collections]>ul').append(collectionResult);
        }else{
          $('#PredictiveWrapper').addClass('hide');
        }
      
        if(pagesSuggestions.length > 0) {
          $('#PredictiveWrapper').removeClass('hide');
          var firstPagesSuggestion = pagesSuggestions[0];
          var pageResult = `<li>
                                <a href="${firstPagesSuggestion.url}">${firstPagesSuggestion.title}</a>
                              </li>`;
          $(document).find('#PredictiveResults [data-type-pages]>ul').append(pageResult);
        }else{
          $('#PredictiveWrapper').addClass('hide');
        }
    }
  });
}

$(document).on('input', '#searchInput', function() {
  if($(this).val() != ''){
    predictiveSearch(this);
  }else{
  $('#PredictiveWrapper').addClass('hide');
  $(document).find('#PredictiveResults [data-type-pages]>ul').empty();
  $(document).find('#PredictiveResults [data-type-products]>.grid').empty();
  $(document).find('#PredictiveResults [data-type-collections]>ul').empty();
  }
});

$(document).on('click', '.header_search svg', function () {
  $(document).find('.header_search_form').addClass('active-form');
  $('body').css('overflow','hidden');
  setTimeout(function () { $('#searchInput-desktop').trigger('focus'); }, 350);
});